import { useEffect } from "react";
import { useCookies } from "react-cookie";

import { createIframe } from "cross-domain-cookie";
import { Box, Paper, Typography } from "@mui/material";

const CrossDomain = () => {
  const [cookies] = useCookies();

  useEffect(() => {
    const dependentDomains = [
      "localhost",
      "test1.com",
      "test2.com",
      "hket89.github.io",
      "dev.tacklit.com",
      "survey.dev.tacklit.co",
    ];

    try {
      // Sets up the contents of the iframe:
      createIframe({ dependentDomains });
    } catch (err) {
      console.error({ err });
    }
  }, []);

  return (
    <Paper>
      <Typography variant="h4">Cookies</Typography>
      <Box padding={2}>
        <pre>{JSON.stringify({ cookies }, null, 2)}</pre>
      </Box>
    </Paper>
  );
};

export default CrossDomain;
